import { useEffect, useState, Fragment } from "react";
import { Container, Grid, Modal } from "@material-ui/core";
import { toast } from "react-toastify";
import ReactLoading from "react-loading";

import { useStyles } from "../../../style";
// import OpenpayIntegration from "../../global/OpenpayIntegration";

const Input = (props) => {
  const { title = "", value, setValue, placeholder = "", type = "text", validationType = "", required = false } = props;

  const handleChange = (e) => {
    let val = e.target.value;

    if (validationType === "month" && val.length > 2) {
      if (val > 12 || val === "00") return;
    } else if (validationType === "year" && val.length > 2) {
      return;
    } else if (validationType === "cvv" && val.length > 4) {
      return;
    }

    setValue(val); // Actualiza el estado
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <label style={{ fontFamily: "m_semi_bold" }}>{title}</label>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        required={required}
        style={{
          fontSize: 16,
          backgroundColor: "#fff",
          border: "none",
          borderRadius: 5,
          paddingLeft: 10,
          marginTop: 10,
          marginBottom: 10,
          height: 50,
        }}
      />
    </div>
  );
};

const ButtonOpenPay = ({ toPay }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState("");
  const [card, setCard] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [cvv, setCvv] = useState("");

  const standBy = () => {};

  const payWithCheckOut = async () => {
    let id = "";

    const cardData = {
      card_number: card,
      holder_name: name,
      expiration_month: month,
      expiration_year: year,
      cvv2: cvv,
    };

    if (!window.OpenPay) {
      console.error("OpenPay no está disponible");
      return;
    }

    window.OpenPay.setId("mvzzvbzfqbphgtrp2oov");
    window.OpenPay.setApiKey("pk_6f3d12b7758f4a72bafdcde56fc52259");
    window.OpenPay.setSandboxMode(true); // true sandbox

    try {
      id = await new Promise((resolve, reject) => {
        window.OpenPay.token.create(
          cardData,
          (success) => {
            console.log("success: ", success);
            resolve(success.data.id);
          },
          (error) => {
            console.error("Error creando token:", error);
            toast.warn("Su tarjeta no es válida, por favor intente de nuevo");
            reject(error);
          }
        );
      });
    } catch (err) {
      console.error("Error en el proceso de pago:", err);
    }

    return id;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // ----------------------------
    // validate
    if (!window.OpenPay.card.validateCardNumber(card)) {
      toast.warn("La tarjeta no es válida, por favor intente de nuevo");
      return;
    }
    if (!window.OpenPay.card.validateExpiry(month, year)) {
      toast.warn("La fecha de expiración no es válida, por favor intente de nuevo");
      return;
    }
    if (!window.OpenPay.card.validateCVC(cvv)) {
      toast.warn("El CVV no es válido, por favor intente de nuevo");
      return;
    }

    // ----------------------------
    // pay

    const id = await payWithCheckOut();
    console.log(">>> id: ", id);

    await toPay("", id);

    setLoading(false);
  };

  return (
    <form onSubmit={onSubmit}>
      <Container maxWidth="md">
        <div style={{ background: "#f5f5f5", padding: 30, borderRadius: 10 }}>
          <div style={{ display: "flex", gap: 10 }}>
            <Input title="Nombre del titular de la tarjeta" value={name} setValue={setName} required />
            <Input title="Número de tarjeta" value={card} setValue={setCard} validationType="card" required />
          </div>

          <div style={{ display: "flex", gap: 10 }}>
            <div style={{ width: "100%" }}>
              <label style={{ fontFamily: "m_semi_bold" }}>Fecha de expiración</label>
              <Input
                placeholder="Mes"
                type="number"
                value={month}
                setValue={setMonth}
                validationType="month"
                required
              />
            </div>
            <div style={{ width: "100%" }}>
              <label style={{ fontFamily: "m_semi_bold" }}> </label>
              <Input placeholder="Año" type="number" value={year} setValue={setYear} validationType="year" required />
            </div>
            <div style={{ width: "100%" }}>
              <label style={{ fontFamily: "m_semi_bold" }}>CVV</label>
              <Input
                placeholder="3-4 dígitos"
                type="password"
                value={cvv}
                setValue={setCvv}
                validationType="cvv"
                required
              />
            </div>
          </div>
        </div>
      </Container>

      <div className={classes.container_payments} style={{ paddingBottom: 30, paddingTop: 30 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 20, width: "100%" }}>
          <div style={{ width: 500 }}>
            <button
              type="submit"
              style={{
                background: "#ffc000",
                color: "#fff",
                textTransform: "uppercase",
                width: "100%",
                height: 60,
                cursor: "pointer",
                border: "none",
                fontSize: 20,
                fontWeight: 600,
                letterSpacing: 4,
                position: "relative",
              }}
            >
              {!loading ? (
                "Pagar"
              ) : (
                <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-10%, -50%)" }}>
                  <ReactLoading type={"bars"} color={"white"} style={{ fill: "#fff", height: 60, width: 60 }} />
                </div>
              )}
            </button>
            {/* <ButtonPayment onClick={loading ? standBy : payWithCheckOut} loading={loading} /> */}
          </div>
        </div>
      </div>
    </form>
  );
};

export default ButtonOpenPay;
